import React from 'react';

const CheckOutButton = ({clickCheckOut, isLoading}) => {
  return (
    <div className={['flex justify-center   ', 'w-full'].join(' ')}>
      <button
        className=" w-5/6 bg-primary  rounded-button py-[12px] text-center text-base  text-white flex justify-center items-center font-semibold gap-3"
        disabled={isLoading}
        onClick={clickCheckOut}>
        <span className=" "> Checkout</span>
      </button>
    </div>
  );
};

export default CheckOutButton;
